class EditCategoryController {
  /* @ngInject */
  constructor($scope, $element, $rootScope, CatalogService, ProductsStore) {
    const that = this;

    that.loading = {
      category: false
    };

    this.isLoadingImage = false;
    this.errorImage = '';

    this.productImage = {
      coverImage: '',
      isCrop: false,
    };

    const init = () => {
      $element.on('change', (e) => {
        this.handleFileSelect(e.target);
      });

      if (that.mode === 'create') {
        that.category = {};
      }

      if(this.category.id)
      {
        loadImageCategory();
      }
    };

    this.$onInit = init;

    const loadImageCategory = () => {
      CatalogService.getImageCategory(that.category.id).then(res => {
        that.productImage.coverImage = res;
      });
    };

    this.saveCategory = () => {
      if(this.mode == 'create')
      {
        CatalogService.createCategory(that.category, $rootScope.parentId).then(
          () => {
            ProductsStore.forceCategoryExpired();
            $rootScope.$broadcast('CATEGORIES_UPDATE');
            that.onCancel();
          }
        );
      }
      else
      {
        CatalogService.editCategory(that.category).then(
          () => {
            ProductsStore.forceCategoryExpired();
            $rootScope.$broadcast('CATEGORIES_UPDATE');
            that.onCancel();
          }
        );
      }
    };

    this.resetModal = () => {
      that.productImage.isCrop = false;
      that.productImage.coverImage = '';
    };

    this.resizeImage = () => {
      that.productImage.isCrop = false;
      that.productImage.coverImage = that.myCroppedCover;
      that.product.img = that.myCroppedCover;
      that.productImage.coverImageBase64 = undefined;
      that.errorImage = '';
    };

    this.handleFileSelect = (evt) => {
      that.errorImage = '';
      if (evt.files === null || evt.files == undefined) return;
      const file = evt.files[0];
      if (file.size > 1048576) {
        that.errorImage = 'Dimensione massima di caricamento 1MB';
        return;
      } else if (!/png/.test(file.type) && !/jpeg/.test(file.type)) {
        that.errorImage = 'Estensione consentita PNG - JPG';
        return;
      }
      that.productImage.isCrop = true;
      const reader = new FileReader();
      reader.onload = (evnt) => {
        $scope.$apply(() => {
          that.productImage.coverImage = evnt.target.result;
          this.category.thumb = that.productImage.coverImage;
        });
      };
      reader.readAsDataURL(file);
    };
  }
}

export default EditCategoryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/categories/edit/edit.controller.js
 **/